
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Punetokolhapurbusonrent() {



  const cardData =
  {
    keyword: ' Pune to Kolhapur Bus on Rent',
    heading: 'Vaishnavi Travels: Pune to Kolhapur Bus on Rent',
    headingDescription: 'Vaishnavi Travels provides dependable and affordable Pune to Kolhapur Bus on Rent, making group travel for family functions, pilgrimages, school trips, and corporate outings comfortable and stress-free. Our buses are well-maintained with spacious seating, powerful air-conditioning, and ample luggage capacity to ensure a smooth ride on the Pune–Kolhapur route. With professional drivers, punctual service, and flexible booking options, we guarantee safety and convenience throughout the journey. Whether it’s a visit to the famous Mahalaxmi Temple, a cultural tour, or a business trip, Vaishnavi Travels offers reliable and comfortable bus rental services from Pune to Kolhapur.',

    top: 'Top Places to Visit in Kolhapur with Vaishnavi Travels',

 "topPlaces": [
  {
    "title": "Mahalaxmi Temple",
    "description": "The Mahalaxmi Temple, also known as Ambabai Temple, is the spiritual heart of Kolhapur and one of the Shakti Peethas of India. Built in the 7th century by the Chalukyas, it is dedicated to Goddess Mahalaxmi, the goddess of wealth and prosperity. Devotees believe that visiting this temple fulfills wishes and brings blessings. The black stone idol is beautifully adorned with jewelry and flowers. Navratri and Kirnotsav (sunray festival) draw thousands of devotees. Mahalaxmi Temple is Kolhapur’s most sacred and iconic landmark."
  },
  {
    "title": "New Palace Museum",
    "description": "The New Palace, constructed in 1884, is a magnificent example of Indo-Saracenic architecture and now serves as a museum. It houses royal memorabilia, weapons, and hunting trophies of the Kolhapur rulers. The Darbar Hall with stained glass windows and portraits is a highlight. Surrounded by lush gardens, the palace reflects regal grandeur. History lovers enjoy exploring its rich exhibits and artifacts. New Palace is Kolhapur’s proud reminder of its royal legacy."
  },
  {
    "title": "Rankala Lake",
    "description": "Rankala Lake, a historic lake built by King Shilahar in the 9th century, is a popular leisure spot in Kolhapur. Locals and tourists come here for evening walks, horse rides, and boating. The surrounding gardens, food stalls, and peaceful environment make it ideal for family outings. Legends associate the lake with Lord Shiva, adding to its significance. Sunsets here are especially enchanting. Rankala Lake is Kolhapur’s natural retreat for relaxation and recreation."
  },
  {
    "title": "Jyotiba Temple",
    "description": "Situated 17 km from Kolhapur, Jyotiba Temple is dedicated to Lord Jyotiba, considered an incarnation of Lord Shiva. Located on a hilltop, the temple attracts thousands of devotees, especially during the annual fairs in March and April. The temple complex resonates with spiritual chants and festive energy. Pilgrims climb steps to reach the shrine, enjoying scenic views along the way. Its pink-colored atmosphere during the fairs is unforgettable. Jyotiba Temple is Kolhapur’s divine hilltop pilgrimage site."
  },
  {
    "title": "Panhala Fort",
    "description": "Panhala Fort, located 20 km from Kolhapur, is the largest fort in the Deccan and a site of great Maratha history. It was an important stronghold of Chhatrapati Shivaji Maharaj. The fort has structures like Teen Darwaza, Andhar Bavadi, and Sajja Kothi that narrate tales of bravery. Visitors enjoy trekking and exploring its ramparts with panoramic valley views. Monsoon adds greenery and mist, enhancing its charm. Panhala Fort is Kolhapur’s historic crown of Maratha pride."
  },
  {
    "title": "Bhavani Mandap",
    "description": "Bhavani Mandap, once the royal court of the Kolhapur kings, is now a historic monument and museum. The building showcases traditional architecture with wooden carvings and open courtyards. Exhibits include statues, weapons, and hunting trophies. Devotees also visit the temple dedicated to Goddess Tulja Bhavani inside the complex. It offers a glimpse into Kolhapur’s royal and cultural life. Bhavani Mandap is Kolhapur’s heritage landmark combining devotion and history."
  },
  {
    "title": "Kaneri Math (Siddhagiri Museum)",
    "description": "Kaneri Math, located near Kolhapur, is a unique open-air museum showcasing a recreated village life in India. Life-size clay models depict over 80 scenes of rural traditions, occupations, and festivals. The museum highlights self-sustainability and Indian culture. Visitors, especially students, find it highly educational and immersive. The peaceful ashram environment adds a spiritual touch to the visit. Kaneri Math is Kolhapur’s cultural heritage village brought to life."
  },
  {
    "title": "Dajipur Wildlife Sanctuary",
    "description": "Also known as the Bison Sanctuary, Dajipur Wildlife Sanctuary is about 80 km from Kolhapur and is home to Indian bison (gaur), leopards, and deer. Nestled in the Sahyadri ranges, it offers safaris, trekking, and bird-watching opportunities. The sanctuary is lush and scenic, especially in monsoon. Nature lovers and wildlife photographers find it a rewarding trip. Dajipur is Kolhapur’s adventurous escape into nature and wildlife."
  },
  {
    "title": "Chhatrapati Shahu Museum",
    "description": "The Chhatrapati Shahu Museum, located inside the New Palace, is dedicated to the history and contributions of the Kolhapur royals. It displays artifacts like royal costumes, weapons, coins, and manuscripts. Visitors learn about Shahu Maharaj’s progressive reforms and leadership. The museum is an educational journey into Maratha history. Its regal interiors add to the experience. Chhatrapati Shahu Museum is Kolhapur’s proud historical showcase."
  },
  {
    "title": "Rautwadi Waterfall",
    "description": "Rautwadi Waterfall, located near Kolhapur, is a hidden natural attraction surrounded by dense forests. The waterfall cascades beautifully during the monsoon, attracting trekkers and nature enthusiasts. The trek to the falls itself is scenic and adventurous. Families and groups enjoy picnics in its refreshing environment. It is a lesser-known but stunning escape from the city. Rautwadi Waterfall is Kolhapur’s natural gem of monsoon beauty and adventure."
  }
],

"services": [
{
"name": "Kolhapur Bus Rental from Pune",
"description": "Convenient and reliable bus rental services from Pune to Kolhapur, catering to groups of all sizes for various travel needs including sightseeing, family trips, and corporate outings. Our fleet includes both AC and non-AC buses, ensuring comfortable journeys with professional drivers who prioritize safety and punctuality. Perfect for long-distance travel with flexible pickup and drop-off locations."
},
{
"name": "AC Bus Pune to Kolhapur",
"description": "Premium air-conditioned bus rentals from Pune to Kolhapur offering a smooth and comfortable ride. Ideal for family tours, office trips, and pilgrimage groups, these buses come equipped with reclining seats, clean interiors, and onboard amenities to make long journeys pleasant and relaxing. Enjoy climate-controlled travel with courteous drivers and timely service."
},
{
"name": "Outstation Bus Pune to Kolhapur",
"description": "Reliable outstation bus hire service from Pune to Kolhapur designed for seamless intercity travel. Whether you are traveling for leisure, business, or religious purposes, our outstation buses provide spacious seating, ample luggage space, and experienced drivers to ensure a safe and stress-free trip across Maharashtra’s scenic routes."
},
{
"name": "Kolhapur Temple Tour Bus",
"description": "Specialized bus services for temple tours in Kolhapur from Pune, catering to devotees and pilgrims. Our buses offer comfortable seating, punctual pickups, and flexible schedules to cover major temples like Mahalaxmi and Jyotiba. With experienced drivers and well-maintained vehicles, we make your spiritual journey smooth and hassle-free."
},
{
"name": "Group Travel Bus Hire Kolhapur",
"description": "Tailored group travel bus hire options for trips to Kolhapur from Pune. Perfect for family reunions, corporate outings, and large friend groups, these buses provide spacious interiors, onboard entertainment, and ample luggage compartments. Flexible booking plans and customized services ensure your group travels together comfortably."
},
{
"name": "Pune to Kolhapur Non AC Bus",
"description": "Affordable non-AC bus rentals for travel from Pune to Kolhapur, ideal for budget-conscious travelers. These buses offer sturdy seating, reliable service, and safety features for short to long-distance trips. Suitable for group tours, educational trips, and casual outings without compromising comfort."
},
{
"name": "40 Seater Kolhapur Bus Pune",
"description": "Spacious 40-seater buses available for Pune to Kolhapur journeys, perfect for medium to large groups. Equipped with comfortable seating, wide aisles, and ample storage, these buses cater to wedding parties, corporate groups, and tourist excursions with flexible timing and professional drivers ensuring smooth travel."
},
{
"name": "Kolhapur Day Trip Bus Hire",
"description": "Ideal bus rental service for day trips from Pune to Kolhapur, providing timely pickups and drop-offs for sightseeing, shopping, and local experiences. Our buses are clean, well-maintained, and staffed with courteous drivers who ensure your day trip is convenient and enjoyable with no transportation hassles."
},
{
"name": "Office Trip Bus to Kolhapur",
"description": "Corporate bus hire service for office trips from Pune to Kolhapur, designed to facilitate group travel for team outings, off-site meetings, or corporate events. These buses include comfortable seating, air-conditioning options, and onboard amenities tailored to enhance productivity and comfort during travel."
},
{
"name": "Pune to Kolhapur Pilgrimage Bus",
"description": "Dedicated pilgrimage bus rental services from Pune to Kolhapur for religious groups visiting temples and holy sites. Offering spacious seating, flexible schedules, and driver expertise on pilgrimage routes, these buses ensure a respectful, comfortable, and safe journey for devotees."
},
{
"name": "Budget Bus Hire Kolhapur Pune",
"description": "Cost-effective bus rental options between Pune and Kolhapur suitable for budget travelers and large groups. Our affordable non-AC and AC buses maintain high safety and comfort standards while offering competitive pricing for weddings, school trips, and casual travel."
},
{
"name": "Kolhapur Outing Bus Rental Pune",
"description": "Reliable outing bus rental services from Pune to Kolhapur for leisure travel, family vacations, and group excursions. These buses offer flexible rental durations, spacious interiors, and professional drivers to ensure enjoyable and hassle-free outings to Kolhapur’s attractions."
},
{
"name": "Book Kolhapur Bus Online",
"description": "User-friendly online booking platform for bus rentals from Pune to Kolhapur, allowing customers to select bus types, compare prices, and reserve vehicles instantly. Features include digital invoicing, customer support, customizable add-ons like decoration and refreshments, and real-time booking confirmations for convenience and transparency."
}
],
"tableData": [
["Kolhapur Bus Rental from Pune", "AC Bus Pune to Kolhapur"],
["Outstation Bus Pune to Kolhapur", "Kolhapur Temple Tour Bus"],
["Group Travel Bus Hire Kolhapur", "Pune to Kolhapur Non AC Bus"],
["40 Seater Kolhapur Bus Pune", "Kolhapur Day Trip Bus Hire"],
["Office Trip Bus to Kolhapur", "Pune to Kolhapur Pilgrimage Bus"],
["Budget Bus Hire Kolhapur Pune", "Kolhapur Outing Bus Rental Pune"],
["Book Kolhapur Bus Online"]
],




"whychoose": [
  {
    "WhyChooseheading": "Reliable Pune to Kolhapur Bus on Rent Service",
    "WhyChoosedescription": "Vaishnavi Travels provides dependable and affordable bus rental services from Pune to Kolhapur, ideal for group travel and events."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Seating",
    "WhyChoosedescription": "Our buses offer ample legroom and cushioned seats to ensure a relaxing journey to Kolhapur for all passengers."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Each bus is regularly serviced and thoroughly cleaned to maintain high standards of safety and hygiene."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages for Pune to Kolhapur Trips",
    "WhyChoosedescription": "Choose from hourly, daily, or multi-day rental options customized to your travel plans and group size."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pune-Kolhapur Route",
    "WhyChoosedescription": "Our professional drivers ensure safe, timely, and courteous service with expert knowledge of the Pune to Kolhapur route."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy all-inclusive pricing covering fuel, tolls, taxes, and driver allowances for a hassle-free rental experience."
  },
  {
    "WhyChooseheading": "Ideal for Corporate Events, Pilgrimage Tours, and Group Travel",
    "WhyChoosedescription": "Perfect for corporate trips, religious tours, sightseeing, and group outings between Pune and Kolhapur."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Vaishnavi Travels provides round-the-clock assistance to help with bookings, itinerary changes, and travel inquiries."
  }
]























  }








const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer bus rental services from Pune to Kolhapur?',
      answer: 'Yes, Vaishnavi Travels provides reliable bus rental services from Pune to Kolhapur, ideal for group travel, corporate trips, family outings, and religious visits.',
    },
    {
      question: 'What types of buses are available for Pune to Kolhapur trips?',
      answer: 'We offer a variety of buses including 32 seater tempo travellers, 40 to 50 seater coaches, both AC and non-AC, suited to different group sizes and preferences.',
    },
    {
      question: 'What is the approximate cost for hiring a bus from Pune to Kolhapur?',
      answer: 'Rental prices vary based on bus type and duration, typically starting from ₹10,000 for a day trip with a 32 seater tempo traveller. Customized quotes are provided according to your itinerary.',
    },
    {
      question: 'Are drivers included in the rental service?',
      answer: 'Yes, all our bus rentals include professional, experienced drivers familiar with the Pune-Kolhapur route to ensure safe and comfortable travel.',
    },
    {
      question: 'Can the itinerary be customized for the Kolhapur trip?',
      answer: 'Absolutely. We tailor the schedule, stops, and timing to fit your group’s needs and preferences.',
    },
    {
      question: 'How far in advance should I book a bus from Pune to Kolhapur?',
      answer: 'Booking 3-5 days ahead is recommended, especially during weekends and holiday seasons, to ensure availability.',
    },
    {
      question: 'Are tolls, parking, and other charges included in the fare?',
      answer: 'Tolls, parking fees, driver allowances, and permits are generally extra and will be clearly communicated in your rental quote.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Sachin Patil",
    position: "Corporate Manager",
    feedback:
      "Vaishnavi Travels provided an excellent bus service for our Pune to Kolhapur corporate trip. The bus was clean, comfortable, and the driver was professional and punctual throughout the journey.",
    rating: 5,
  },
  {
    name: "Mrs. Neha Kulkarni",
    position: "Family Trip Organizer",
    feedback:
      "We rented a 40 seater AC bus for our family trip to Kolhapur. The vehicle was spacious and well-maintained. The driver was courteous and made our long journey pleasant. Very happy with the service!",
    rating: 5,
    style: "style-2",
  }
];






















































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Kolhapur Bus on Rent",
  "image": "https://vaishnavitravel.com/assets/images/pune-to-kolhapur-bus.jpg",
  "description": "Book Pune to Kolhapur bus on rent with Vaishnavi Travels for comfortable AC and Non AC buses ideal for group travel, office trips, pilgrimage tours, and day trips.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.79",
    "ratingCount": "1300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3800",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/pune-to-kolhapur-bus-on-rent"
  }
};



  return (
    <div>

<Helmet>
  <title>Pune to Kolhapur Bus on Rent | AC & Non AC Group Bus Hire | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Book Pune to Kolhapur bus on rent with Vaishnavi Travels for comfortable AC and Non AC buses ideal for group travel, office trips, pilgrimage tours, and day trips."
  />
  <meta
    name="keywords"
    content="Kolhapur Bus Rental from Pune, AC Bus Pune to Kolhapur, Outstation Bus Pune to Kolhapur, Kolhapur Temple Tour Bus, Group Travel Bus Hire Kolhapur, Pune to Kolhapur Non AC Bus, 40 Seater Kolhapur Bus Pune, Kolhapur Day Trip Bus Hire, Office Trip Bus to Kolhapur, Pune to Kolhapur Pilgrimage Bus, Budget Bus Hire Kolhapur Pune, Kolhapur Outing Bus Rental Pune, Book Kolhapur Bus Online"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/26.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetokolhapurbusonrent;